import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useSupplierTypeReducer = () => useSelector((state: ApplicationState) => state.supplierType);
